import { CARRIER_TENDERED_MODULE_WEB, DRIVER_ASSIGNED_MODULE_WEB } from 'app/utils/constants';
import { IRoute } from './sidebar.schema';
export const noAccessUrl = '/app/noAccess';


export const sideBarTabs = (isDispatcher?:boolean):IRoute[] =>{
  return [
  {
    label: 'Home',
    path: '/app/home',
    slug: 'home',
    icon: 'nav-home-icon.svg',
    visibilityKey : "homeTab"
  },
  {
    label: 'Search',
    path: '/app/search',
    slug: 'search',
    icon: 'search_icon_desktop.svg',
    visibilityKey : "searchTab"
  },
  {
    label: 'My Loads',
    path: isDispatcher ? CARRIER_TENDERED_MODULE_WEB : DRIVER_ASSIGNED_MODULE_WEB ,
    slug: 'myLoad',
    icon: 'My Load.svg',
    visibilityKey : "myLoadTab"
  },
  {
    label: "My Drivers",
    path: "/app/manage/ManageUser",
    slug: "my_drivers",
    icon: "my-driver.svg",
    visibilityKey: "myDriverTab",
  },
  {
    label: 'Manage Capacity',
    path: '/app/manage-capacity',
    slug: 'manage',
    icon: 'manage_capacity_icon.svg',
    visibilityKey : "manageCapacityTab"
  },
  {
    label: 'Fuel Savings',
    path: '#',
    slug: 'fuel_saving',
    icon: 'fuel_nozzle.svg',
    visibilityKey : "fuelSavingTab",
  },
  {
    label: 'Trailer Rental',
    path: '',
    slug: 'trailer_lease',
    icon: 'trailer.svg',
    visibilityKey : "tailerLeaseTab"
  },
  {
    label: 'More',
    path: '',
    slug: 'moretab',
    icon: 'more-icon.svg',
    visibilityKey : "moreTab",
    subCategory: [
      {
        label: 'Feedback',
        path: '/app/feedback',
        slug: 'feedback',
        icon: 'Feedback-web.svg',
    visibilityKey : "feedBackTab"
      },
      {
        label: 'Preferences',
        path: '/app/preferences',
        slug: 'preferences',
        icon: 'Preferences-web.svg',
    visibilityKey : "preferenceTab"
      },
      {
        label: 'Support',
        path: '/app/support',
        slug: 'more',
        icon: 'Support-web.svg',
    visibilityKey : "supportTab"
      }
    ]
  }
];
}

export const fuleSavingVisibility = (_routes: any, IONICWrapper: any) => {
  const fuelSavingVisibilityFlag =
    IONICWrapper &&
    IONICWrapper.details.keys &&
    IONICWrapper.details.keys.configuration &&
    IONICWrapper.details.keys.configuration.fuelSaving &&
    IONICWrapper.details.keys.configuration.fuelSaving.visibility;
  if (fuelSavingVisibilityFlag === false) {
    return _routes.filter((item: any) => item.slug !== 'fuel_saving');
  }
  return _routes;
};
